export const REFUND_STATUS = Object.freeze({
  PENDING: "P",
  CANCELLED: "C",
  CREDIT_RELEASED: "L",
  DANIED: "D",
  IN_ANALYSIS: "A"
});

export const REFUND_STATUS_LABELS = Object.freeze({
  [REFUND_STATUS.PENDING]: "Aguardando regularização",
  [REFUND_STATUS.CANCELLED]: "Cancelado",
  [REFUND_STATUS.CREDIT_RELEASED]: "Crédito liberado",
  [REFUND_STATUS.DANIED]: "Negado",
  [REFUND_STATUS.IN_ANALYSIS]: "Em análise"
});
